import { createVanIconComponent } from "./van"

const WapHome = createVanIconComponent("wap-home")
export default WapHome
